// src/Components/SignupForm.jsx
import React, { useState, useMemo } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../css/Login.css';

export default function SignupForm() {
  const [form, setForm] = useState({
    username: '',
    password: '',
    name: '',
    department: '',
    email: '',
    phone: '',
  });
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState(null);
  const navigate = useNavigate();

  const emailOk = useMemo(() => {
    if (!form.email) return false;
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim());
  }, [form.email]);

  const phoneOk = useMemo(() => {
    if (!form.phone) return false;
    // 숫자/하이픈만 허용, 숫자 9자리 이상 권장
    const digits = form.phone.replace(/[^0-9]/g, '');
    return digits.length >= 9;
  }, [form.phone]);

  const canSubmit =
    form.username.trim().length > 0 &&
    form.password.trim().length >= 4 &&
    form.name.trim().length > 0 &&
    form.department.trim().length > 0 &&
    emailOk &&
    phoneOk &&
    !loading;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!canSubmit) return;

    setLoading(true);
    setMsg(null);

    try {
      await axios.post(
        '/api/signup',
        {
          username: form.username.trim(),
          password: form.password,
          name: form.name.trim(),
          department: form.department.trim(),
          email: form.email.trim(),
          phone: form.phone.trim(),
        },
        { headers: { 'Content-Type': 'application/json' } }
      );

      setMsg({ type: 'ok', text: '✅ 회원가입이 완료되었습니다. 로그인해주세요.' });
      setForm({
        username: '',
        password: '',
        name: '',
        department: '',
        email: '',
        phone: '',
      });

      setTimeout(() => navigate('/login', { replace: true }), 500);
    } catch (err) {
      const status = err?.response?.status;
      const text =
        err?.response?.data?.message ||
        (status === 409
          ? '❌ 이미 존재하는 사용자입니다.'
          : '❌ 회원가입에 실패했습니다.');
      setMsg({ type: 'err', text });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="Logo-container">DMSYSTEM ENGENIERING</div>
      <div className="login-box">
        <div className="login-form-container">
          <form onSubmit={handleSubmit}>
            <h1>회원가입</h1>

            <input
              name="username"
              value={form.username}
              onChange={handleChange}
              placeholder="아이디"
              autoComplete="username"
            />

            <input
              name="password"
              type="password"
              value={form.password}
              onChange={handleChange}
              placeholder="비밀번호 (4자 이상)"
              autoComplete="new-password"
            />

            <input
              name="name"
              value={form.name}
              onChange={handleChange}
              placeholder="이름"
              autoComplete="given-name"
            />

            <input
              name="department"
              value={form.department}
              onChange={handleChange}
              placeholder="부서"
              autoComplete="organization"
            />

            <input
              name="email"
              type="email"
              value={form.email}
              onChange={handleChange}
              placeholder="이메일"
              autoComplete="email"
            />
            {!emailOk && form.email && (
              <div style={{ color: '#f87171', fontSize: 12, marginTop: 4 }}>
                올바른 이메일 형식을 입력하세요.
              </div>
            )}

            <input
              name="phone"
              value={form.phone}
              onChange={handleChange}
              placeholder="휴대폰 번호 (예: 010-1234-5678)"
              autoComplete="tel"
            />
            {!phoneOk && form.phone && (
              <div style={{ color: '#f87171', fontSize: 12, marginTop: 4 }}>
                숫자 9자리 이상으로 입력하세요. 하이픈(-)은 포함해도 됩니다.
              </div>
            )}

            <button type="submit" disabled={!canSubmit}>
              {loading ? '처리 중…' : '회원가입'}
            </button>

            {msg && <div>{msg.text}</div>}
          </form>
        </div>
      </div>
    </div>
  );
}
